import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X, ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/config/site'

export function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const isHome = location.pathname === '/'

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setMobileMenuOpen(false)
  }, [location])

  return (
    <>
      <header
        className={cn(
          'fixed top-0 left-0 right-0 z-40 transition-all duration-500 border-b',
          scrolled || !isHome
            ? 'bg-background/80 backdrop-blur-xl border-white/5 py-4'
            : 'bg-transparent border-transparent py-6'
        )}
      >
        <div className="container flex justify-between items-center">
          <Logo />

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {siteConfig.navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  'text-sm font-semibold transition-colors',
                  location.pathname === item.href
                    ? 'text-white'
                    : 'text-slate-400 hover:text-white'
                )}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="btn btn-primary text-sm px-6 py-2.5"
            >
              Get Started
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: '100vh' }}
            exit={{ opacity: 0, height: 0 }}
            className="fixed inset-0 z-30 bg-background pt-28 px-6 md:hidden overflow-hidden"
          >
            <div className="flex flex-col gap-8">
              {siteConfig.navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-4xl font-bold text-white/80 hover:text-white text-left transition-colors"
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-primary text-xl font-bold mt-4"
              >
                Get Started <ArrowRight size={20} />
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

function Logo() {
  return (
    <Link
      to="/"
      className="flex items-center cursor-pointer group"
    >
      <img
        src="/nexaigen-logo-agency.png"
        alt="NEXAIGEN - Apps, Web, Online Marketing Agency"
        className="h-24 md:h-28 w-auto transition-transform duration-300 group-hover:scale-105"
      />
    </Link>
  )
}

export default Header
